import { Button } from '@mui/material';
import React from 'react';
import { UserRole, UserOperation } from '../../types/user';
import AccessDeniedImg from '../../resources/undraw-secure-data.svg';
import './index.css';
import useOperationAuthorizationChecks from '../../hooks/useOperationAuthorizationChecks';
import { getUserProfile } from '../../utilities/AuthService';
import { useNavigate } from 'react-router-dom';

type AuthorizationProtectedProps = {
  children: JSX.Element | React.ReactNode;
  requiredRole?: UserRole;
  requiredOperations?: Array<UserOperation>;
};

function AuthorizationProtected({ children, requiredRole, requiredOperations }: AuthorizationProtectedProps): JSX.Element | null {
  const user = getUserProfile();
  const hasRequiredRole = requiredRole ? user?.Role.includes(requiredRole) : true;
  const isAuthorized = useOperationAuthorizationChecks(requiredOperations || []);
  const navigate = useNavigate();

  if (hasRequiredRole && isAuthorized) {
    return <>{children}</>;
  }

  function handleBack() {
    navigate(-1);
  }

  return (
    <div className='authorization-protected_403'>
      <div className='authorization-protected_403-title'>You are not authorized to view this page</div>
      <img className='authorization-protected_403-img' src={AccessDeniedImg} alt='404' />
      <div className='authorization-protected_403-actions'>
        <Button className='authorization-protected_403-link' variant='contained' color='primary' onClick={handleBack}>
          Back
        </Button>
      </div>
    </div>
  );
}

export default AuthorizationProtected;
